/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountId,
  ArrayOwnershipSchedulingLinkV2,
  ArrayRoundRobinSchedulingLinkV2,
  MapString,
  OwnershipSchedulingLinkV2,
  OwnershipSchedulingLinkV2CreateRequest,
  OwnershipSchedulingLinkV2UpdateRequest,
  PublicGroupSchedulingLink,
  PublicOwnershipSchedulingLink,
  PublicRoundRobinSchedulingLink,
  RequiresLicenseSetOwnershipSchedulingLinkV2,
  RequiresLicenseSetRoundRobinSchedulingLinkV2,
  RoundRobinSchedulingLinkV2,
  RoundRobinSchedulingLinkV2CreateRequest,
  RoundRobinSchedulingLinkV2UpdateRequest,
  ScheduleMeetingRequestV2,
  ScheduleMeetingResponseV2,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "team-scheduling";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @name FindRoundRobinSchedulingLinksByWorkspaceIdV2
   * @request GET:/v2/tenant/{tenantId}/round-robin-scheduling-links/find-by-workspace-id
   * @secure
   */
  findRoundRobinSchedulingLinksByWorkspaceIdV2 = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayRoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/round-robin-scheduling-links/find-by-workspace-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRoundRobinSchedulingLinksByWorkspaceIdV2 */
  findRoundRobinSchedulingLinksByWorkspaceIdV2PathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/round-robin-scheduling-links/find-by-workspace-id`, query);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkBySlugV2
   * @request GET:/v2/guest-external/tenant/{tenantId}/round-robin-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findARoundRobinSchedulingLinkBySlugV2 = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      PublicRoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/round-robin-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkBySlugV2 */
  findARoundRobinSchedulingLinkBySlugV2PathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v2/guest-external/tenant/${tenantId}/round-robin-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindRoundRobinSchedulingLinksByUserIdV2
   * @request GET:/v2/tenant/{tenantId}/round-robin-scheduling-links/find-by-user-id
   * @secure
   */
  findRoundRobinSchedulingLinksByUserIdV2 = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RequiresLicenseSetRoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/round-robin-scheduling-links/find-by-user-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRoundRobinSchedulingLinksByUserIdV2 */
  findRoundRobinSchedulingLinksByUserIdV2PathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/round-robin-scheduling-links/find-by-user-id`, query);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdV2
   * @request GET:/v2/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdV2 = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      RoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdV2 */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdV2PathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
  ) => this.getServicePath(`/v2/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`);

  /**
   * No description
   *
   * @name UpdateARoundRobinSchedulingLinkV2
   * @request PUT:/v2/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  updateARoundRobinSchedulingLinkV2 = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: RoundRobinSchedulingLinkV2UpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      RoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateARoundRobinSchedulingLinkV2 */
  updateARoundRobinSchedulingLinkV2PathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`, query);

  /**
   * No description
   *
   * @name DeleteARoundRobinSchedulingLinkV2
   * @request DELETE:/v2/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  deleteARoundRobinSchedulingLinkV2 = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteARoundRobinSchedulingLinkV2 */
  deleteARoundRobinSchedulingLinkV2PathGetter = (tenantId: string, roundRobinSchedulingLinkId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV2
   * @request GET:/v2/guest-external/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV2 = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PublicRoundRobinSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV2 */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV2PathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
  ) =>
    this.getServicePath(
      `/v2/guest-external/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
    );

  /**
   * No description
   *
   * @name CreateANewRoundRobinSchedulingLinkV2
   * @request POST:/v2/tenant/{tenantId}/round-robin-scheduling-links
   * @secure
   */
  createANewRoundRobinSchedulingLinkV2 = (
    tenantId: string,
    data: RoundRobinSchedulingLinkV2CreateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      RoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/round-robin-scheduling-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createANewRoundRobinSchedulingLinkV2 */
  createANewRoundRobinSchedulingLinkV2PathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/round-robin-scheduling-links`);

  /**
   * No description
   *
   * @name FindOwnershipSchedulingLinksByWorkspaceIdV2
   * @request GET:/v2/tenant/{tenantId}/ownership-scheduling-links/find-by-workspace-id
   * @secure
   */
  findOwnershipSchedulingLinksByWorkspaceIdV2 = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayOwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/ownership-scheduling-links/find-by-workspace-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findOwnershipSchedulingLinksByWorkspaceIdV2 */
  findOwnershipSchedulingLinksByWorkspaceIdV2PathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/ownership-scheduling-links/find-by-workspace-id`, query);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkBySlugV2
   * @request GET:/v2/guest-external/tenant/{tenantId}/ownership-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findAOwnershipSchedulingLinkBySlugV2 = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      PublicOwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/ownership-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkBySlugV2 */
  findAOwnershipSchedulingLinkBySlugV2PathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v2/guest-external/tenant/${tenantId}/ownership-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindOwnershipSchedulingLinksByUserIdV2
   * @request GET:/v2/tenant/{tenantId}/ownership-scheduling-links/find-by-user-id
   * @secure
   */
  findOwnershipSchedulingLinksByUserIdV2 = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RequiresLicenseSetOwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/ownership-scheduling-links/find-by-user-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findOwnershipSchedulingLinksByUserIdV2 */
  findOwnershipSchedulingLinksByUserIdV2PathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/ownership-scheduling-links/find-by-user-id`, query);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdV2
   * @request GET:/v2/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdV2 = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdV2 */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdV2PathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
  ) => this.getServicePath(`/v2/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`);

  /**
   * No description
   *
   * @name UpdateAOwnershipSchedulingLinkV2
   * @request PUT:/v2/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  updateAOwnershipSchedulingLinkV2 = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: OwnershipSchedulingLinkV2UpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAOwnershipSchedulingLinkV2 */
  updateAOwnershipSchedulingLinkV2PathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`, query);

  /**
   * No description
   *
   * @name DeleteAOwnershipSchedulingLinkV2
   * @request DELETE:/v2/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  deleteAOwnershipSchedulingLinkV2 = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAOwnershipSchedulingLinkV2 */
  deleteAOwnershipSchedulingLinkV2PathGetter = (tenantId: string, ownershipSchedulingLinkId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV2
   * @request GET:/v2/guest-external/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV2 = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PublicOwnershipSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV2 */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV2PathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
  ) =>
    this.getServicePath(
      `/v2/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
    );

  /**
   * No description
   *
   * @name CreateANewOwnershipSchedulingLinkV2
   * @request POST:/v2/tenant/{tenantId}/ownership-scheduling-links
   * @secure
   */
  createANewOwnershipSchedulingLinkV2 = (
    tenantId: string,
    data: OwnershipSchedulingLinkV2CreateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      OwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/ownership-scheduling-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createANewOwnershipSchedulingLinkV2 */
  createANewOwnershipSchedulingLinkV2PathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/ownership-scheduling-links`);

  /**
   * No description
   *
   * @name FindAGroupSchedulingLinkBySlugV2
   * @request GET:/v2/guest-external/tenant/{tenantId}/group-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findAGroupSchedulingLinkBySlugV2 = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      PublicGroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/group-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAGroupSchedulingLinkBySlugV2 */
  findAGroupSchedulingLinkBySlugV2PathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v2/guest-external/tenant/${tenantId}/group-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindAGroupSchedulingLinkByGroupSchedulingLinkIdPublicV2
   * @request GET:/v2/guest-external/tenant/{tenantId}/group-scheduling-links/{groupSchedulingLinkId}
   * @secure
   */
  findAGroupSchedulingLinkByGroupSchedulingLinkIdPublicV2 = (
    tenantId: string,
    groupSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PublicGroupSchedulingLink,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAGroupSchedulingLinkByGroupSchedulingLinkIdPublicV2 */
  findAGroupSchedulingLinkByGroupSchedulingLinkIdPublicV2PathGetter = (
    tenantId: string,
    groupSchedulingLinkId: string,
  ) => this.getServicePath(`/v2/guest-external/tenant/${tenantId}/group-scheduling-links/${groupSchedulingLinkId}`);

  /**
   * @description Returns a MeetingId if the request was accepted and Error otherwise
   *
   * @name ScheduleAMeetingV2GuestEndpoint
   * @request POST:/v2/guest-external/tenant/{tenantId}/meeting
   * @secure
   */
  scheduleAMeetingV2GuestEndpoint = (tenantId: string, data: ScheduleMeetingRequestV2, params: RequestParams = {}) =>
    this.request<
      ScheduleMeetingResponseV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/guest-external/tenant/${tenantId}/meeting`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleAMeetingV2GuestEndpoint */
  scheduleAMeetingV2GuestEndpointPathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/guest-external/tenant/${tenantId}/meeting`);
}
